/** Opt-in marker: any element carrying this attribute (or its descendants) blocks right-click/drag saving. */
export const PROTECTED_IMAGE_ATTR = 'data-protected-image';

const BLOCKED_EVENTS = ['contextmenu', 'dragstart'] as const;

// Deterrent only — images are already watermarked, low-res and short-lived server-side.
export function installImageProtection(doc: Document): () => void {
  const block = (event: Event) => {
    if (event.target instanceof Element && event.target.closest(`[${PROTECTED_IMAGE_ATTR}]`)) {
      event.preventDefault();
    }
  };

  BLOCKED_EVENTS.forEach((type) => doc.addEventListener(type, block));

  return () => BLOCKED_EVENTS.forEach((type) => doc.removeEventListener(type, block));
}
